import React, { useState } from 'react';
import TabButton from './TabButton';
import OutputArea from './OutputArea';

interface CodeOutputTabsProps {
  output: string[] | null;
  isError: boolean;
  language: string;
  tabs: { label: string; id: number; active: boolean }[];
  activeTab?: number;
  setActiveTab?: (index: number) => void;
  explanationContent?: string;
  tipContent?: string;
  htmlOutput?: string;
  isHtmlOutput?: boolean;
  debugAiResponse?: string | null;
  explainHighlightedAiResponse?: string | null;
  debugAiLoading?: boolean;
  explainHighlightedAiLoading?: boolean;
  debugError?: string | null;
  explainHighlightedError?: string | null;
  resultSet?:
    | {
        columns: string[];
        rows: any[][];
      }
    | undefined;
  resultSets?: {
    columns: string[];
    rows: any[][];
  }[];
  isWaitingForInput?: boolean;
  inputPrompt?: string;
  currentInput?: string;
  onInputChange?: (value: string) => void;
  onInputSubmit?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  terminalOutput?: string[];
}

const CodeOutputTabs: React.FC<CodeOutputTabsProps> = ({
  output,
  isError,
  language,
  tabs,
  activeTab = 0,
  setActiveTab,
  explanationContent,
  tipContent,
  htmlOutput,
  isHtmlOutput,
  debugAiResponse,
  explainHighlightedAiResponse,
  debugAiLoading,
  explainHighlightedAiLoading,
  debugError,
  explainHighlightedError,
  resultSet,
  resultSets,
  isWaitingForInput,
  inputPrompt,
  currentInput,
  onInputChange,
  onInputSubmit,
  terminalOutput,
}) => {
  return (
    <div className="w-full max-w-screen-xl space-y-2 mx-auto mt-6 mb-8 select-none">
      <div className="border-b border-gray-300 overflow-x-auto overflow-y-hidden scrollbar-hide">
        <div className="flex whitespace-nowrap">
          {tabs.map((tab) => (
            <TabButton
              key={tab.label}
              label={tab.label}
              isActive={activeTab === tab.id - 1}
              onClick={() => setActiveTab && setActiveTab(tab.id - 1)}
            />
          ))}
        </div>
      </div>
      <OutputArea
        activeTab={activeTab.toString()}
        output={output}
        isError={isError}
        explanationContent={explanationContent}
        tipContent={tipContent}
        htmlOutput={htmlOutput}
        isHtmlOutput={isHtmlOutput}
        language={language}
        debugAiResponse={debugAiResponse}
        explainHighlightedAiResponse={explainHighlightedAiResponse}
        debugAiLoading={debugAiLoading}
        explainHighlightedAiLoading={explainHighlightedAiLoading}
        debugError={debugError}
        explainHighlightedError={explainHighlightedError}
        resultSet={resultSet}
        resultSets={resultSets}
        isWaitingForInput={isWaitingForInput}
        inputPrompt={inputPrompt}
        currentInput={currentInput}
        onInputChange={onInputChange}
        onInputSubmit={onInputSubmit}
        terminalOutput={terminalOutput}
      />
    </div>
  );
};

export default CodeOutputTabs;
